import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { fontDisplay, fontUi, opticalCenter, pill, viewMoreLink } from '../../theme/typography';

export const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
  margin-top: 0px;
  width: 100%;
  order: 4;
  background: transparent;
  color: ${({ theme }) => theme.text};
  @media screen and (max-width: 1199px) {
    width: 100%;
    margin-top: 0px;
  }
`;

export const StyledViewMore = styled(Link)`
  ${viewMoreLink};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.card};
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  padding: 22px 12px 8px;
  color: ${({ theme }) => theme.text};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const StyledDatePill = styled.span`
  ${pill};
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  background: ${({ theme }) => (theme.isDark ? theme.hover : '#ececec')};
  color: ${({ theme }) => theme.textMuted};
  z-index: 2;
`;

export const StyledSeason = styled.div`
  display: none;
`;

export const StyledMatchResult = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin: 4px 0 8px;
  border: 0;
  padding: 0;

  > span {
    ${fontDisplay};
    font-size: 22px;
    color: ${({ theme }) => theme.textFaint};
  }
`;

export const StyledButton = styled(Link)`
  ${viewMoreLink};
`;

export const StyledScore = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > h6 {
    ${fontDisplay};
    ${opticalCenter};
    color: ${({ theme }) => theme.text};
    text-align: center;
    padding: 0;
    margin: 0;
    font-size: 28px;
    letter-spacing: -0.02em;
    text-transform: none;

    @media screen and (max-width: 1199px) {
      font-size: 22px;
    }
  }
`;

export const StyledTeamsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  margin-top: 8px;
`;

export const StyledHeader = styled.div`
  display: none;
`;

export const StyledDate = styled.span`
  ${fontUi};
  color: ${({ theme }) => theme.textFaint};
  font-size: 11px;
  font-weight: 500;
`;

export const StyledCenterBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledTeam = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 33%;
  text-align: center;
  cursor: pointer;
  span {
    ${fontUi};
    font-size: 13px;
    font-weight: 700;
    margin-top: 8px;
    color: ${({ theme }) => theme.text};
    line-height: 1.2;
    @media only screen and (max-width: 1199px) {
      font-size: 11px;
    }
  }
  img {
    max-width: 50px;
    height: auto;
  }
`;
